<template>
    <div style="width: 90%;height:100%;margin:1% auto;display:flex;">
        <!-- 介绍 -->
        <el-card style="width:30%;height:600px;display: inline-block;margin-right: 3%;">
            <div slot="header" class="clearfix" style="display: inline-block;height: 100%;width: 10%;">
                <span>Contact Us</span>
            </div>
            <div>
                <div style="height: auto;margin: 5%;">
                    <strong ><i class="el-icon-location"></i> Location</strong>
                    <p style="margin-top: 10%;" >
                        Central South University, YueLu District, Changsha, Hunan, China
                    </p>
                </div>
                <hr>
                <div style="height: auto;margin: 5%;">
                    <strong><i class="el-icon-phone"></i> Telephone</strong>
                    <p style="margin-top: 10%;">
                        +86-139-7513-4596<br/>
                        +86-193-7515-6973
                    </p>
                </div>
                
                <hr>
                <div style="height: auto;margin: 5%;">
                    <strong><i class="el-icon-message"></i> Email</strong>

                    <p class="text-muted" style="margin-top: 10%;">
                        <a href="mailto:xxx@163.com">
                            limin@mail.csu.edu.cn<br/>
                            yichaozhao@csu.edu.cn
                        </a>
                    </p>
                </div>
            </div>
        </el-card> 

        <!-- 问答 -->
        <el-collapse v-model="activeCollapse" @change="handleChange" style="width: 70%; margin-left:5%;height: auto;text-align: left;">
            <el-collapse-item name="use">
                <template slot="title">
                <i class="el-icon-question"></i>&nbsp What MDDOmics can do?
                </template>
                <div class="answer">MDDOmics provides browse, search, downstream analysis and visualization of multi-omics data related to MDD, 
                    as well as multi-omics data of MDD-similar disorders. It provides researchers 
                    with available data and broader ideas for cross-analysis among diseases and differentiation of similar diseases.<br/>

                    From here:<br/>
                    <ul>
                    <li>You can browse multi-omics data of MDD and MDD-similar disorders.</li>
                    <li>After getting some conclusions from experiments, you can search to see whether your results are the same as those reported previously.</li>
                    <li>You can get ideas from the analysis results for subsequent research.</li>
                    <li>You can get the information of interest intuitively through the visualization tools.</li>
                    <li>Data can be downloaded for research and analysis.</li>
                    </ul>
                </div>
            </el-collapse-item>

            <el-collapse-item name="new">
                <template slot="title">
                <i class="el-icon-question"></i>&nbsp How to submit new data?
                </template>
                <div class="answer">If you have new data to submit, we warmly welcome you to share your original research data or findings.
                    Please send the data to our email yichaozhao@csu.edu.cn, and include details such as the type of data, 
                    quantity, author names, publication date, 
                    links to related papers, 
                and whether the dataset has been integrated into other databases, among other information. 
                <br/>We will conduct a review and processing of the submitted data and provide you with timely feedback.</div>
            </el-collapse-item>
            
            <el-collapse-item name="annotation">
                <template slot="title">
                <i class="el-icon-question"></i>&nbsp How is the data annotated?
                </template>
                <div class="answer"> 
                    Annotations related to genes:<br>
                    <ul>
                        <li>Gene: <a href="https://www.ncbi.nlm.nih.gov/gene">https://www.ncbi.nlm.nih.gov/gene</a></li>
                        <li>HGNC: <a href="https://www.genenames.org/">https://www.genenames.org/</a></li>
                        <li>bioMart: <a href="https://bioconductor.org/packages/release/bioc/html/biomaRt.html">https://bioconductor.org/packages/release/bioc/html/biomaRt.html</a></li>
                        <li>clusterProfiler: <a href="https://bioconductor.org/packages/release/bioc/html/clusterProfiler.html">https://bioconductor.org/packages/release/bioc/html/clusterProfiler.html</a></li>
                    </ul>
                    Annotations related to SNP:<br>
                    <ul>
                        <li>dbSNP: <a href="https://www.ncbi.nlm.nih.gov/snp">https://www.ncbi.nlm.nih.gov/snp</a>/</li>
                        <li>bioMart: <a href="https://bioconductor.org/packages/release/bioc/html/biomaRt.html">https://bioconductor.org/packages/release/bioc/html/biomaRt.html</a></li>
                        <li>clusterProfiler: <a href="https://bioconductor.org/packages/release/bioc/html/clusterProfiler.html">https://bioconductor.org/packages/release/bioc/html/clusterProfiler.html</a></li>
                    </ul>
                     Annotations related to ncRNA:<br>
                    <ul>
                        <li>LNCipedia: <a href="https://lncipedia.org/">https://lncipedia.org/</a></li>
                        <li>miRbase: <a href="https://www.mirbase.org">https://www.mirbase.org</a>/</li>
                        <li>Circad: <a href="http://clingen.igib.res.in/circad/">http://clingen.igib.res.in/circad/</a></li> 
                        <li>circBase: <a href="http://www.circbase.org/">http://www.circbase.org/</a></li>
                    </ul>
                  
                </div>
            </el-collapse-item>



            <el-collapse-item name="cite">
                <template slot="title">
                <i class="el-icon-question"></i>&nbsp How to cite MDDOmics?
                </template>
                <div class="answer">
                    Use data from 'browse' and 'search': Please cite the source literature or database of the data. <br/>
                    <ul>
                        <li><a href="https://www.disgenet.org/">DisGENET v7.0: </a>Piñero, Janet, et al. "The DisGeNET knowledge platform for disease genomics: 2019 update." Nucleic acids research 48.D1 (2020): D845-D855.</li>
                        <li><a href="http://dbbip.xialab.info/">dbBIP: </a>Li, Xiaoyan, et al. "dbBIP: a comprehensive bipolar disorder database for genetic research." Database 2022 (2022): baac049.</li>
                        <li><a href="https://bioinfo.uth.edu/SZGR/index.jsp">SZGR v2.0: </a>Jia, Peilin, et al. "SZGR 2.0: a one-stop shop of schizophrenia candidate genes." Nucleic acids research 45.D1 (2017): D915-D924.</li>
                        <li><a href="http://www.szdb.org/">SZDB v2.0: </a>Wu, Yong, et al. "SZDB2. 0: an updated comprehensive resource for schizophrenia research." Human genetics 139 (2020): 1285-1297.</li>
                        <li><a href="http://www.rnanut.net/lncrnadisease/">LncRNADisease v3.0: </a>Chen, Geng, et al. "LncRNADisease: a database for long-non-coding RNA-associated diseases." Nucleic acids research 41.D1 (2012): D983-D986.<br> Bao, Zhenyu, et al. "LncRNADisease 2.0: an updated database of long non-coding RNA-associated diseases." Nucleic acids research 47.D1 (2019): D1034-D1037.</li>
                        <li><a href="https://github.com/bioinforlab/CircR2Disease-v2.0">CircR2Disease v2.0:</a>Fan, Chunyan, et al. "CircR2Disease v2. 0: an updated web server for experimentally validated circRNA–disease associations and its application." Genomics, Proteomics and Bioinformatics 20.3 (2022): 435-445.</li>
                        <li><a href="http://www.rnadisease.org/">RNADisease v4.0: </a>Chen, Jia, et al. "RNADisease v4. 0: an updated resource of RNA-associated diseases, providing RNA-disease analysis, enrichment and prediction." Nucleic Acids Research 51.D1 (2023): D1397-D1404.</li>
                        <li><a href="https://menda.cqmu.edu.cn/">proMENDA: </a>Pu, Juncai, et al. "MENDA: a comprehensive curated resource of metabolic characterization in depression." Briefings in bioinformatics 21.4 (2020): 1455-1464.</li>
                    </ul>
                   
                    Use this database or analysis and visualization results please cite: <br/>
                    
                </div>
                
            </el-collapse-item>

          
            
            <el-collapse-item name="link">
                <template slot="title">
                <i class="el-icon-question"></i>&nbsp Related Publications & Useful Links
                </template>
                <div class="answer">
                    Visit our group's homepage to see more projects and publications we have completed or are working on:<br>
                    <ul>
                        <li><a href="http://bioinformatics.csu.edu.cn/">http://bioinformatics.csu.edu.cn/</a></li>
                        <li><a href="http://bioinformatics.csu.edu.cn/limin/">http://bioinformatics.csu.edu.cn/limin/</a></li>
                    </ul>
                  
                  
                </div>
            </el-collapse-item>
            
            <el-collapse-item name="question">
                <template slot="title">
                <i class="el-icon-question"></i>&nbsp Other question
                </template>
                <div class="answer">For any questions and suggestions, please contact us.</div>
            </el-collapse-item>
            
        </el-collapse>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        activeCollapse: ['use']
      };
    },
    methods: {
      handleChange(val) {

      }
    }
  }
</script>

<style>

.el-collapse-item__header{
  font-size: 18px !important;
  color: #464646;
}

.card {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 0 solid rgba(0,0,0,.125);
    border-radius: .25rem;
    box-shadow: 0 0 1px rgb(0 0 0 / 13%), 0 1px 3px rgb(0 0 0 / 20%);
    margin-bottom: 1rem;

}

hr{
    width:90%;
    border:none;
    border-top:2px solid  rgba(0,0,0,.125);
}
.el-icon-question{
    margin-left:1%;
}
.answer{
    margin-left:30px;
    margin-right:30px;
    margin-top:20px;
    font-size:15px;
}
</style>